import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA } from '@angular/material/legacy-snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { GenericApiErrorComponent } from '@shared/components/error/generic-api-error/generic-api-error.component';
import { ErrorCode } from '@shared/models/error-code.enum';

@Component({
  selector: 'ten-activate-validation-error',
  templateUrl: './activate-validation-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatLegacyCardModule, NgIf, TranslateModule, GenericApiErrorComponent],
})
export class ActivateValidationErrorComponent implements OnInit {
  public errorMessageTypeFromCode: string;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}

  public ngOnInit() {
    let code: string;
    if (this.data?.length) {
      code = this.data[0].code || null;
    }

    switch (code) {
      case ErrorCode.InvalidActivationToken:
      case ErrorCode.ActivationToken:
        this.errorMessageTypeFromCode = 'invalidToken';
        break;
      case ErrorCode.IncorrectOldPassword:
        this.errorMessageTypeFromCode = 'invalidOldPassword';
        break;
      case ErrorCode.SameAsPrevious:
        this.errorMessageTypeFromCode = 'sameAsPrevious';
        break;
      case ErrorCode.WrongSecurityQuestionAnswer:
        this.errorMessageTypeFromCode = 'wrongSecurityQuestionAnswer';
        break;
      default:
        this.errorMessageTypeFromCode = 'default';
        break;
    }
  }
}
